import { initFileDownloadPolling } from './fileDownloadPolling';
import { useAppStore } from '../../store/store';

initFileDownloadPolling(useAppStore);
